import React from 'react'
import {
  SectionHeader,
  SectionHeaderData,
  SectionWrapper,
} from '@components/common'
import { FeatureRenderer } from '@utils/hoc'
import { TabPanelSection } from '@utils/shared/components'
import {
  MultiFeatureSection,
  MultiFeatureSectionData,
} from '../MultiFeatureSection'

export type ScrollableMultiFeatureSectionData = {
  multiFeatureSections: MultiFeatureSectionData[]
  sectionHeaderData?: SectionHeaderData
  darkBg?: boolean
}

export type ScrollableMultiFeatureSectionProps =
  ScrollableMultiFeatureSectionData & {
    showDivider?: 'top' | 'bottom' | 'both' | 'none'
    alternateSectionBg?: boolean
  }

export function ScrollableMultiFeatureSection({
  showDivider,
  darkBg = false,
  multiFeatureSections,
  sectionHeaderData,
  alternateSectionBg = false,
}: ScrollableMultiFeatureSectionProps) {
  const sectionsData = multiFeatureSections.map((feature, index) => {
    const label =
      feature.data.sectionHeaderData?.sectionTagData?.label ||
      (feature.data.sectionHeaderData?.heading as string) ||
      `Section ${index + 1}`
    const id = label
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')

    return {
      name: id,
      position: index,
    }
  })

  return (
    <>
      {sectionHeaderData && (
        <SectionWrapper
          alternateBg={darkBg}
          alternateSectionBg={alternateSectionBg}
        >
          <FeatureRenderer data={sectionHeaderData} Component={SectionHeader} />
        </SectionWrapper>
      )}

      {/* Wrapper so sticky TabPanelSection is constrained to this section only */}
      <div>
        <TabPanelSection
          items={sectionsData}
          compact={false}
          scrollOffset={150}
          csx={{
            overflowBoxWrapper: {
              maxWidth: '1248px',
              margin: 'auto',
            },
          }}
        />
        {multiFeatureSections.map((item, idx) => {
          const label =
            item.data.sectionHeaderData?.sectionTagData?.label ||
            (item.data.sectionHeaderData?.heading as string) ||
            `Section ${idx + 1}`
          const id = label
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '')

          return (
            <div key={idx} id={id}>
              <FeatureRenderer
                key={`${item.variant}-${idx}`}
                data={item}
                Component={MultiFeatureSection}
                showDivider={showDivider}
                alternateSectionBg={alternateSectionBg}
              />
            </div>
          )
        })}
      </div>
    </>
  )
}
